<script setup>
definePage({
  meta: {
    requiresAuth: true,
  },
});
</script>

<template>
  <div class="dashboard">
    <VCard>
      <VCardText>
        <h1 class="text-h4 mb-4">Bem-vindo ao Sistema</h1>
        <p class="text-body-1">Você está logado com sucesso!</p>
      </VCardText>
    </VCard>
  </div>
</template>

<style scoped>
.dashboard {
  padding: 24px;
}
</style>
